const MODULE = 'DEPT_POPULAR_PRODUCT'

export const DEPT_POPULAR_PRODUCT = `${MODULE}_DEPT_POPULAR_PRODUCT`
